import { __assign } from "tslib";
import { createHttpTestKit } from '../../http/test-kit';
import { AuthType } from '../../domain';
import { createAccountSettingsApi, accountApiRelativePath, authApiRelativePath } from './index';
import { createFakeGetResponder, createFakePostResponder, createFakePutResponder, createFakeDeleteResponder, isWildcard } from '../../test-utils';
export var createAccountSettingsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createAccountSettingsApi('', fakeHttp);
    var testKit = {
        whenGetAccountTimezone: function () {
            return createFakeGetResponder(fakeHttp, "".concat(accountApiRelativePath, "/timezone"));
        },
        whenSetAccountTimezone: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(accountApiRelativePath, "/timezone"))(dto);
        },
        whenGetAccountName: function () { return createFakeGetResponder(fakeHttp, "".concat(accountApiRelativePath, "/name")); },
        whenSetAccountName: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(accountApiRelativePath, "/name"))(dto);
        },
        whenGetAccountLocales: function () {
            return createFakeGetResponder(fakeHttp, "".concat(accountApiRelativePath, "/locales"));
        },
        whenAddAccountLocale: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(accountApiRelativePath, "/locales"))(dto);
        },
        whenRemoveAccountLocale: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "".concat(accountApiRelativePath, "/locales/").concat(isWildcard(dto) ? 'en' : dto.locale));
        },
        whenChangeAccountOwner: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(accountApiRelativePath, "/owner"))(dto);
        },
        whenGetSamlLoginSettings: function () { return createFakeGetResponder(fakeHttp, "".concat(authApiRelativePath, "/providers?authType=").concat(AuthType.SAML, "&authMethodType=").concat(0)); },
        whenSetSamlLoginSettings: function (dto) { return createFakePostResponder(fakeHttp, "".concat(authApiRelativePath, "/providers"))(dto); },
        whenUpdateSamlLoginSettings: function (dto) { return createFakePutResponder(fakeHttp, "".concat(authApiRelativePath, "/providers"))(dto); },
        whenGetAuthenticationOptions: function () { return createFakeGetResponder(fakeHttp, "".concat(accountApiRelativePath, "/login")); },
        whenEnableAuthProvider: function (dto) { return createFakePostResponder(fakeHttp, "".concat(authApiRelativePath, "/providers/enable"))(dto); },
        whenDisableAuthProvider: function (dto) { return createFakePostResponder(fakeHttp, "".concat(authApiRelativePath, "/providers/disable"))(dto); },
        whenToggleGoogleLogin: function (enabled) { return createFakePutResponder(fakeHttp, "".concat(accountApiRelativePath, "/login/google/enabled"))({ enabled: enabled }); },
        whenToggleInternalLogin: function (enabled) {
            return createFakePutResponder(fakeHttp, "".concat(accountApiRelativePath, "/login/internal/enabled"))({ enabled: enabled });
        },
        whenGetTenantEnabledChannels: function () { return createFakeGetResponder(fakeHttp, "".concat(accountApiRelativePath, "/activities")); }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map